import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPrimaryData, setFootprintingCropPrimaryDataAdmin } from "services";

import { getEnvironment } from "utils";

import {
  FOOTPRINTING_CROP,
  FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW,
  FOOTPRINTING_CROP_CALCULATED_FOOTPRINT,
  FOOTPRINTING_CROP_PRIMARY_DATA,
} from "consts";

import { FootprintingCropPrimaryData } from "models";

export const useMutateFootprintingCropPrimaryData = (
  farmId: string,
  cropId: string,
  year: number,
  payload: Omit<FootprintingCropPrimaryData, "id">,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropPrimaryDataAdmin : setFootprintingCropPrimaryData;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, primaryDataId],
          [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, cropId, year],
          [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, farmId, cropId, year],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, farmId],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
